import dayjs from 'dayjs';
import autoTable from 'jspdf-autotable';
import ReportCoreMixin from '@shared_mixins/report/report.core.mixin.js';
import {mapGetters, mapState} from 'vuex';
import background_texture_img from '@shared/assets/img/background_texture.png';
import KSTEELLogoWhite from '@shared/assets/img/ksteel_logo_white.png';
import KSTEELLogo from '@shared/assets/img/ksteel_logo.png';
import QESGLogoWhite from '@shared/assets/img/QuantifiedESG_Logo_v3_White.png';
import ShortcutIcon from '@shared/assets/img/IcBaselineShortcut.png';
import {waitTime} from '@shared/utils/common';
import {
    mapCampaignIdToCompanySize,
    codeResult,
    rgbaToRgb,
    summaryMsg, convertSubCodeToCode
} from '@shared/mixin/report/raw-data/ksteel-2025';

const {ksteelReportYear} = require('./report-ksteel-year.cjs');

export default {
    mixins: [
        ReportCoreMixin
    ],
    data() {
        return {
            ksteel_colors: {
                primary: '#2C2A54',
                primary_rgb: [44, 42, 84],
                selected: '#3e3b7a',
                compliance: '#084f6a',
                compliance_rgb: [8, 79, 106],
                nonCompliance: '#c00000',
                nonCompliance_rgb: [192, 0, 0],
                secondary: '#e97132',
                warning: '#c04f15',
                error: '#D9534F',
                error_rgb: [217, 83, 79],
                gray: '#B0B0C0',
                muted: '#747373',
                state: {
                    A: [49, 133, 157],
                    B: [147, 204, 221],
                    C: [241, 220, 219],
                    D: [192, 80, 79],
                    N: [116, 115, 115],
                }
            },
            codeDoughnutChartInstance: null,
            codeDoughnutChartInstanceImg: null,
            
            mapSubCodeToScoringPd: {},
            auditData: {},
            linkDestinationInfo: {
                toImprovement : {},
                toAppendix: {},
            },
            overAllScore: {
                total: null,
                social: null,
                environment: null
            }
        };
    },
    computed: {
        ...mapState('evaluations', ['audit_category']),
        ...mapGetters('evaluations', ['get_audit_category_name']),
        headerInfo() {
            const _user_input_company_name = this.reportData.info.users.find(({criteria_name}) => criteria_name === '회사명');
            return {
                company_id: this.reportData?.info?.company.id,
                request_id: this.reportData?.info?.id,
                company_name: _user_input_company_name?.value || this.reportData?.info?.company?.company_name,
                vendor_code: this.reportData?.info?.vendor_code,
                published_date: this.reportData?.info?.completed_ts
            };
        },
        _jsPDF_headerStyles() {
            return {
                fontSize: 8.5,
                fillColor: [44, 42, 84],
                textColor: [255, 255, 255]
            };
        },
        companyInfo() {
            const _company_info = {
                '매출액': ' - ',
                '회사명': this.reportData.info.company.company_name,
                '기업규모': mapCampaignIdToCompanySize[this.reportData.info.campaign.id],
                '근로자수': ' - ',
                '근로자_정규직': ' - ',
                '근로자_계약직': ' - ',
                '근로자_일용직': ' - ',
            };
            if (!this.reportData?.parser_result?.values.length) {
                return _company_info;
            } else {
                this.reportData?.parser_result.values.forEach((info) => {
                    _company_info[info.criteria_name] = info.value.length ? info.value[0] : ' - ';
                });
                
                return _company_info;
            }
        },
        assessmentInfo() {
            let {
                service_type,
                requested_ts,
                in_progress_ts,
                in_assessment_ts,
                duedate_ts,
                completed_ts,
                project_code
            } = this.reportData.info;
            service_type = service_type === '일반' ? this.$t('일반 평가', this.report_lang) : this.$t('심화 평가', this.report_lang);
            
            let _assessmentInfo = {
                service_type: null, requested_date: requested_ts, duedate_date: duedate_ts, completed_date: completed_ts, project_code
            };
            
            if (service_type) _assessmentInfo.service_type = this.$t(service_type, this.report_lang);
            
            // 평가기간 실 평가기간으로 교체
            if (_assessmentInfo.requested_date) {
                _assessmentInfo.requested_date = this.report_lang === 'ko'
                    ? dayjs(_assessmentInfo.requested_date).format('YYYY년 MM월 DD일')
                    : dayjs(_assessmentInfo.requested_date).format('MM/DD/YYYY');
            } else {
                _assessmentInfo.requested_date = ' - ';
            }
            
            if (_assessmentInfo.duedate_date) {
                _assessmentInfo.duedate_date = this.report_lang === 'ko'
                    ? dayjs(_assessmentInfo.duedate_date).format('YYYY년 MM월 DD일')
                    : dayjs(_assessmentInfo.duedate_date).format('MM/DD/YYYY');
            } else {
                _assessmentInfo.duedate_date = ' - ';
            }
            
            if (_assessmentInfo.completed_date) {
                _assessmentInfo.completed_date = this.report_lang === 'ko'
                    ? dayjs(_assessmentInfo.completed_date).format('YYYY년 MM월 DD일')
                    : dayjs(_assessmentInfo.completed_date).format('MM/DD/YYYY');
            } else {
                _assessmentInfo.completed_date = dayjs().format(this.report_lang === 'ko' ? 'YYYY년 MM월 DD일' : 'MM/DD/YYYY');
            }
            
            return _assessmentInfo;
        },
        levelData(){
            if(this.reportData?.results?.length < 1) return {};
            const [_, total, category1, category2, category3 ] = this.reportData.results;
            
            const processedTotalCodeData = {
                compliance: 0,
                nonCompliance: 0,
                total: 0,
                A: 0,
                B: 0,
                C: 0,
                D: 0,
            };
            category3.data.forEach(cate3 => {
                if(cate3.category3_ev_code == null) return;
                if(cate3.category3_ev_code !== 'N' ){
                    processedTotalCodeData.total += 1;
                }
                if(cate3.category3_ev_code === 'A' || cate3.category3_ev_code === 'B'){
                    processedTotalCodeData.compliance += 1;
                    
                    if(cate3.category3_ev_code === 'A'){
                        processedTotalCodeData.A += 1;
                    }
                    if(cate3.category3_ev_code === 'B'){
                        processedTotalCodeData.B += 1;
                    }
                }
                if(cate3.category3_ev_code === 'C' || cate3.category3_ev_code === 'D'){
                    processedTotalCodeData.nonCompliance += 1;
                    
                    if(cate3.category3_ev_code === 'C'){
                        processedTotalCodeData.C += 1;
                    }
                    if(cate3.category3_ev_code === 'D'){
                        processedTotalCodeData.D += 1;
                    }
                }
            });
            
            
            return {
                total: {
                    ...total.data[0],
                    total_compliance: this.roundToOneDecimalPlace(total.data?.[0]?.total_compliance ?? 0)
                }, category1: category1.data, category2: category2.data , category3: category3.data, processedTotalCodeData
            };
        },
        subBaseData(){
            const unknownData = {
                total: 0,
                unknown: this.reportData.results[5].data[0].unknown_count,
                validRate: 0,
            };
            const mapSubCodeData = {};
            this.reportData.sources.sub_data.forEach(sub => {
                if (sub.sub_code.includes('ST')) return;
                if(sub.ev_code !== 'N') {
                    unknownData.total += 1;
                }
                mapSubCodeData[sub.sub_code] = sub;
            });
            unknownData.validRate = this.roundToOneDecimalPlace(((unknownData.total - unknownData.unknown) / unknownData.total) * 100);
            
            return {unknownData, mapSubCodeData};
        },
        evBaseData() {
            const mapEvData = {};
            const processedEvData = {};
            
            this.reportData.sources.raw_data.forEach(raw => {
                const currentCode = convertSubCodeToCode(raw.sub_code);
                if (mapEvData[currentCode] == null) {
                    mapEvData[currentCode] = {};
                }
                if (mapEvData[currentCode][raw.sub_code] == null) {
                    mapEvData[currentCode][raw.sub_code] = [];
                }
                mapEvData[currentCode][raw.sub_code].push(raw);
            });
            Object.entries(mapEvData).forEach(([key, subEvData]) => {
                processedEvData[key] = {};
                Object.entries(subEvData).forEach(([subCode, items]) => {
                    processedEvData[key][subCode] = {
                        isNA: false
                    };
                    const targetSub =  this.subBaseData.mapSubCodeData[subCode];
                    
                    // 문항이 해당 없음의 경우
                    if(targetSub.ev_code == null || targetSub.ev_code === 'N') {
                        processedEvData[key][subCode].isNA = true;
                        return;
                    }
                    
                    // 문항이 해당 없음이 아닌 경우
                    let selectedResultNoEv = null;
                    let selectedUnknownEv = null;
                    let  resultNoEv = null;
                    const removeIdx = [];
                    items.forEach((item,idx) => {
                        if(item.formula === '"아니오" == result'){
                            removeIdx.push(idx);
                            resultNoEv = item;
                            if(item.satisfied === true && item.not_applicable === false){
                                selectedResultNoEv = item;
                            }
                        }
                        if(item.formula === '"모름" == result') {
                            removeIdx.push(idx);
                            if(item.satisfied === true && item.not_applicable === false){
                                selectedUnknownEv = item;
                            }
                        }
                    });
                    // 아니오, 모름 평가지표 제거
                    const processedEvList = items.filter((_, idx) => !removeIdx.includes(idx));
                    // 예 하위지표 있는지 체크
                    const noLowerEv = items.every((item) => item.neg_ev_code == null);
                    
                    const getNegEv = (item, audit_category = null) => {
                        let auditCategory = item.judged_by === 'audit' ? item.audit_category_code : 'EV_AUTO';
                        if(audit_category != null) {
                            auditCategory = audit_category;
                        }
                        return {
                            ev_code: item.neg_ev_code.split('::')[0],
                            judged_by: item.judged_by,
                            comment: {ko: item.comment, ea: item.comment_ea, ca: item.comment_ca,},
                            audit_category_code: auditCategory,
                            ev_name:  {ko: item.reverse_name, ea: item.reverse_name_ea, ca: item.reverse_name_ca}
                        };
                    };
                    // "result = 아니오" 인 경우
                    if(selectedResultNoEv != null){
                        
                        let auditCategory = selectedResultNoEv.judged_by === 'audit' ? selectedResultNoEv.audit_category_code : 'EV_AUTO';
                        // 사용자가 해당 없음을 선택했으나 근거가 인정되지 않아 아니오로 처리된 경우, auditCategory custom 변경
                        if(selectedResultNoEv.origin_ev_code === 'N' &&  selectedResultNoEv.satisfied === true){
                            auditCategory = 'EV_NOT_NA';
                        }
                        // "예" 하위 평가 지표가 없는 경우 또는 B321 문항의 경우
                        if(noLowerEv || subCode === 'B3-2.1'){
                            processedEvData[key][subCode][selectedResultNoEv.ev_id] =  {
                                ev_code: selectedResultNoEv.ev_code,
                                judged_by: selectedResultNoEv.judged_by,
                                comment: {ko: selectedResultNoEv.comment, ea: selectedResultNoEv.comment_ea, ca: selectedResultNoEv.comment_ca,},
                                audit_category_code: auditCategory,
                                ev_name:  {ko: selectedResultNoEv.name, ea: selectedResultNoEv.name_ea, ca: selectedResultNoEv.name_ca,}
                            };
                        }
                        // "예" 하위 평가 지표가 있는 경우
                        else {
                            processedEvList.forEach((item) => {
                                processedEvData[key][subCode][item.ev_id] = getNegEv(item, auditCategory);
                            });
                        }
                    }
                    // "result = 모름" 인 경우
                    else if(selectedUnknownEv != null){
                        let auditCategory = selectedUnknownEv.judged_by === 'audit' ? selectedUnknownEv.audit_category_code : 'EV_AUTO';
                        // 사용자가 해당 없음을 선택했으나 근거가 인정되지 않아 아니오로 처리된 경우, auditCategory custom 변경
                        if(selectedUnknownEv.origin_ev_code === 'N' &&  selectedUnknownEv.satisfied === true){
                            auditCategory = 'EV_NOT_NA';
                        }
                        
                        // "예" 하위 평가 지표가 없는 경우 또는 B321 문항의 경우
                        if(noLowerEv || subCode === 'B3-2.1'){
                            processedEvData[key][subCode][selectedUnknownEv.ev_id] =  {
                                ev_code: resultNoEv.pos_ev_code, // 모름 수준 === 아니오 수준
                                judged_by: selectedUnknownEv.judged_by,
                                comment: {ko: selectedUnknownEv.comment, ea: selectedUnknownEv.comment_ea, ca: selectedUnknownEv.comment_ca,},
                                audit_category_code: auditCategory,
                                ev_name:  {ko: selectedUnknownEv.name, ea: selectedUnknownEv.name_ea, ca: selectedUnknownEv.name_ca,}
                            };
                        }
                        // "예" 하위 평가 지표가 있는 경우
                        else {
                            processedEvList.forEach((item) => {
                                processedEvData[key][subCode][item.ev_id] = getNegEv(item, auditCategory);
                            });
                        }
                    }
                    // "result = 예" 인 경우
                    else {
                        if(noLowerEv){
                            const selectedResultYesEv = processedEvList.find(item => item.satisfied === true && item.not_applicable === false);
                            processedEvData[key][subCode][selectedResultYesEv.ev_id] = {
                                ev_code: selectedResultYesEv.ev_code,
                                judged_by: selectedResultYesEv.judged_by,
                                comment: {ko: selectedResultYesEv.comment, ea: selectedResultYesEv.comment_ea, ca: selectedResultYesEv.comment_ca,},
                                audit_category_code: selectedResultYesEv.audit_category_code,
                                ev_name:  {ko: selectedResultYesEv.name, ea: selectedResultYesEv.name_ea, ca: selectedResultYesEv.name_ca,}
                            };
                            if(selectedResultYesEv.origin_ev_code === selectedResultYesEv.ev_code || selectedResultYesEv.judged_by !== 'audit') {
                                processedEvData[key][subCode][selectedResultYesEv.ev_id].audit_category_code = 'EV_AUTO';
                            }
                        }
                        else {
                            processedEvList.forEach((item) => {
                                processedEvData[key][subCode][item.ev_id] = {
                                    ev_code: item.ev_code,
                                    judged_by: item.judged_by,
                                    comment: {ko: item.comment, ea: item.comment_ea, ca: item.comment_ca,},
                                    audit_category_code: item.audit_category_code,
                                    ev_name:  {ko: item.name, ea: item.name_ea, ca: item.name_ca,}
                                };
                                if(item.satisfied === false){
                                    processedEvData[key][subCode][item.ev_id].ev_name = {ko: item.reverse_name, ea: item.reverse_name_ea, ca: item.reverse_name_ca};
                                }
                                if(item.origin_ev_code === item.ev_code || item.judged_by !== 'audit') {
                                    processedEvData[key][subCode][item.ev_id].audit_category_code = 'EV_AUTO';
                                }
                            });
                        }
                        
                    }
                    Object.keys(processedEvData).forEach(key => {
                        const sortedEntries = Object.keys(processedEvData[key])
                            .sort((a, b) => a.localeCompare(b))
                            .reduce((acc, subCode) => {
                                acc[subCode] = processedEvData[key][subCode];
                                return acc;
                            }, {});
                        processedEvData[key] = sortedEntries;
                    });
                });
            });
            
            return {mapEvData, processedEvData};
        }
    },
    watch: {},
    created() {
    },
    methods: {
        async generatePDF_ksteel(doc, position_top) {
            try {
                this.pageContentWidth = doc.internal.pageSize.width - (this.jsPDFOpt.margin.left + this.jsPDFOpt.margin.right);
                this.pageContentHeight = doc.internal.pageSize.height - (this.jsPDFOpt.margin.top + this.jsPDFOpt.margin.bottom);
                
                this.generateCover_ksteel(doc);
                
                this.addDocPage(doc);
                this.addHeader(doc, 2);
                
                let position_y = await this.createSummaryPage_v4(doc, position_top);
                position_y = await this.createCodeSummaryPage(doc, position_y);
                position_y = await this.createCodeResultPage(doc, position_y);
                
                if (this.reportMode === 'full') {
                    position_y = await this.createAppendixPage(doc, position_y);
                }
                
                const totalPages = doc.getNumberOfPages();
                for (let i = 2; i <= totalPages; i++) {
                    doc.setPage(i);  // 현재 페이지로 이동
                    this.addFooter(doc);
                }
                
                doc.setDocumentProperties({
                    title: this.pdf_filename,
                    subject: this.pdf_filename,
                    filename: `${this.pdf_filename}.pdf`,
                    author: 'QuantifiedESG Inc.',
                    creator: 'QESG'
                });
            } catch (e) {
                console.error('err', e);
                console.dir(e);
            }
            
            
            return doc;
        },
        addFooter (doc) {
            // this.setFont(doc)
            this.setFont(doc, 'table_td', null, 'semibold');
            doc.setFontSize(this.jsPDFOpt.footerStyles.fontSize);
            doc.setFillColor(...this.jsPDFOpt.footerStyles.fillColor);
            
            const pageHeight = doc.internal.pageSize.getHeight();
            const [footerBox_position_x, footerBox_position_y] = [0, pageHeight - this.jsPDFOpt.footerHeight];
            const footerBox_width = doc.internal.pageSize.getWidth();
            doc.rect(footerBox_position_x, footerBox_position_y, footerBox_width, this.jsPDFOpt.footerHeight, 'F');
            
            // const _page_total = doc.internal.getNumberOfPages();
            const _page_total = doc.getNumberOfPages() - 1;
            const _page_current = doc.getCurrentPageInfo().pageNumber;
            
            // (좌측) QESG 로고
            const logo_max_height = 15;
            const logo_QESG_width = (40 * logo_max_height) / 10;
            const logo_QESG_position_y = pageHeight - (this.jsPDFOpt.footerHeight / 2) - 7.5;
            doc.addImage(this.qesg_logo_png, 'png', this.jsPDFOpt.margin.left, logo_QESG_position_y, logo_QESG_width, logo_max_height);
            // (우측) 철강협호;  로고
            const logo_ksteel_max_height = 272 / 14;
            const logo_ksteel_width = 990 / 14;
            const logo_ksteel_position_y = pageHeight - (this.jsPDFOpt.footerHeight / 2) - 9.5;
            doc.addImage(KSTEELLogo, 'png', this.jsPDFOpt.margin.left + 68, logo_ksteel_position_y, logo_ksteel_width, logo_ksteel_max_height);
            // (우측) 페이지 넘버
            doc.setFontSize(10);
            const _footer_pages = doc.splitTextToSize(`${_page_current - 1} / ${_page_total}`, footerBox_width - this.jsPDFOpt.margin.right);
            const _footer_pages_height = doc.getTextDimensions(_footer_pages).h;
            const _footer_pages_width = doc.getTextDimensions(_footer_pages).w;
            const _footer_pages_position_x = footerBox_width - _footer_pages_width - (this.jsPDFOpt.margin.left);
            const _footer_pages_position_y = footerBox_position_y + (this.jsPDFOpt.footerHeight / 2) + (_footer_pages_height / 2);
            doc.text(_footer_pages, _footer_pages_position_x, _footer_pages_position_y);
        },
        async createSummaryPage_v4(doc, position_y) {
            position_y = this.firstElementSpacing;
            position_y = this.addTitle(doc, position_y, 1, 'ESG 평가 결과 요약');
            position_y = this.summary_processCompanyInfo(doc, position_y);
            
            const {
                chartXPos,
                rightContentXPos,
                position_y: after_position_y
            } = await this.summary_processCodeCompliance(doc, position_y);
            position_y = after_position_y;
            position_y = await this.summary_processUnknown(doc, position_y, chartXPos, rightContentXPos);
            
            return position_y;
        },
        async createCodeSummaryPage(doc, position_y) {
            this.addDocPage(doc);
            this.addHeader(doc, 2);
            
            position_y = this.firstElementSpacing;
            position_y = await this.codeSummary_AreaCompliance(doc, position_y);
            position_y = await this.codeSummary_CodeCompliance(doc, position_y);
            
            return position_y;
        },
        async createCodeResultPage(doc, position_y) {
            for (const codeResult of this.reportData.results[4].data) {
                if (codeResult.category3_question_name.includes('기본')) continue;
                this.addDocPage(doc);
                this.addHeader(doc, 2);
                
                position_y = this.firstElementSpacing;
                position_y = this.addTitle(doc, position_y, 1, this.$t('코드별 평가결과 요약', this.report_lang));
                position_y = await this.codeResult_summary(doc, position_y, codeResult);
                position_y = await this.codeResult_scoreCard(doc, position_y, codeResult);
                position_y = await this.codeResult_nonComplianceDetail(doc, position_y, codeResult);
            }
            
            return position_y;
        },
        async createAppendixPage(doc, position_y) {
            this.addDocPage(doc);
            this.addHeader(doc, 2);
            
            const leftStart = this.jsPDFOpt.margin.left;
            
            position_y = this.firstElementSpacing;
            const title = `Appendix ${this.companyInfo.회사명} ${this.$t('답변과 평가 근거', this.report_lang)}`;
            position_y = this.addTitle(doc, position_y, 1, title);
            
            let cate3Idx = 0;
            for (const cate3 of this.reportData.results[4].data) {
                cate3Idx += 1;
                if (cate3.category3_question_name.includes('기본')) continue;
                
                const code = cate3.category3_question_name.split('.')[0];
                const targetCodeEvData =  this.evBaseData.processedEvData[code];
                
              
                const codeTitle = `Code ${cate3.category3_question_name}`;
                position_y = this.addTitle(doc, position_y, 2, codeTitle, {skip_divider: true});
                
                
                const entriesTargetCodeEvData =  Object.entries(targetCodeEvData);
                entriesTargetCodeEvData.forEach(([subCode, evItems], idx) => {
                    const checkLast = idx === entriesTargetCodeEvData.length -1 && cate3Idx === this.reportData.results[4].data.length;
                    const targetSub = this.subBaseData.mapSubCodeData[subCode];
                    const targetCodeLevelDesc = this.reportData.ev_code_list.find(item => item.code === (targetSub.ev_code ?? 'N')).description;
                    const subEvCode = targetSub.ev_code;
                    const isSubNonCompliance = (subEvCode === 'D' || subEvCode === 'C');
                    
                    const subTitle = `[${targetSub.label}] ${this.$t('문항 수준', this.report_lang)}: ${targetCodeLevelDesc}`;
                    const subTitleYPos = position_y + 4;
                    this.setFont(doc, 'table_td', null, 'medium');
                    doc.setTextColor(29, 29, 29);
                    doc.setFontSize(11.5);
                    doc.text(subTitle, leftStart, subTitleYPos);
                    
                    position_y += 8;
                    
                    if(evItems.isNA){
                        const emptyCardYPos = position_y + 2;
                        doc.setDrawColor('#c2bfbf');
                        doc.setLineWidth(0.6);
                        doc.setFillColor(...rgbaToRgb([...this.ksteel_colors.state.N, 0.25]));
                        doc.rect(leftStart, emptyCardYPos, this.pageContentWidth, 20, 'FD');
                        this.setFont(doc, 'table_td', null, 'medium');
                        doc.setFontSize(11);
                        doc.setTextColor('#666666');
                        doc.text('-', leftStart + this.pageContentWidth / 2, emptyCardYPos + 13, {align: 'center'});
                        
                        position_y += 36;
                        
                        
                        
                        
                        if (!checkLast) {
                            if(this.checkNeedNewPage(doc, position_y, 70)){
                                this.addDocPage(doc, true);
                                this.addHeader(doc, 2);
                                position_y = this.firstElementSpacing;
                            }
                        }
                        
                        return;
                    }
                    
                    const legendList =  [
                        {value: this.$t('매우 미흡', this.report_lang), color: this.ksteel_colors.state.D},
                        {value: this.$t('미흡', this.report_lang), color: this.ksteel_colors.state.C},
                        {value: this.$t('보통', this.report_lang), color: this.ksteel_colors.state.B},
                        {value: this.$t('우수', this.report_lang), color: this.ksteel_colors.state.A}
                    ];
                    
                    this.setFont(doc, 'table_td', null, 'normal');
                    doc.setTextColor('#666666');
                    doc.setFontSize(9);
                    
                    let baseXPos = leftStart + this.pageContentWidth;
                    legendList.forEach(({value, color}, index) => {
                        const legendMsg = doc.splitTextToSize(value, this.pageContentWidth);
                        const legendMsgDim = doc.getTextDimensions(legendMsg);
                        const legendPosX = baseXPos - legendMsgDim.w;
                        doc.text(legendMsg, legendPosX, position_y + 2);
                        
                        // 첫 번째가 아니면 쉼표 추가
                        const textWithComma = index > 0 ? value + ',' : value;
                        doc.text(textWithComma, legendPosX, position_y + 2);
                        
                        // 원형 태그 위치 계산
                        const circleRadius = 3;
                        const circleX = legendPosX - circleRadius - 4; // 텍스트 왼쪽에 원 배치
                        const circleY = position_y;
                        
                        // 원형 배경 (border 없음)
                        doc.setDrawColor('#232323');
                        doc.setLineWidth(1);
                        doc.setFillColor(...color);
                        doc.circle(circleX, circleY, circleRadius, 'F');
                        
                        baseXPos = circleX - circleRadius - 8; // 다음 항목 시작 위치
                    });
                    
                    this.setFont(doc, 'table_td', null, 'normal');
                    doc.setTextColor('#666666');
                    doc.setFontSize(9);
                    doc.text(this.$t('범례', this.report_lang) + ':', baseXPos - 12, position_y + 2);
                    
                    
                    position_y += 10;
                    
                    const thStyle = {
                        ...this.tableStyles.th,
                        lineColor: '#232323',
                        halign: 'center',
                        fontStyle: 'bold',
                    };
                    
                    const tableBody = [
                        [
                            {
                                content: this.$t('수준', this.report_lang),
                                styles: {...thStyle }
                            },
                            {
                                content: this.$t('평가 요소', this.report_lang),
                                colSpan: 2,
                                styles: {...thStyle }
                            },
                            {
                                content: this.$t('평가 근거 ', this.report_lang),
                                colSpan: 2,
                                styles: {...thStyle }
                            },
                        ]
                    ];

                    Object.entries(evItems).forEach(([ev_id, evItem]) => {
                        if(ev_id === 'isNA') return;
                        
                        const evName = evItem.ev_name[this.report_lang] || (evItem.ev_name['ko'] ?? '-');
                        const evComment = evItem.comment[this.report_lang] || (evItem.comment['ko'] ?? '-');
                        const ev_code = evItem.ev_code;
                        let auditCategory = evItem.audit_category_code;
                        
                        
                        const isNonCompliance = (ev_code === 'D' || ev_code === 'C');
                        
                        const tdStyle = {
                            ...this.tableStyles.td,
                            lineColor: '#232323',
                            halign: 'center',
                            fontStyle: 'normal',
                        };
                        
                        const target_audit_category = this.audit_category.find(cat => cat.code === auditCategory);
                        
                        if(evItem.audit_category_code === 'EV_AUTO'){
                            auditCategory = '';
                        }
                        else if(evItem.audit_category_code === 'EV_NOT_NA'){
                            auditCategory = this.$t('해당없음 사유 인정 불가', this.report_lang);
                        }
                        else if(evItem.audit_category_code === 'EV_NOBASE'){
                            auditCategory = this.$t('제출 증빙 내 근거 불충분', this.report_lang);
                        }
                        else {
                            auditCategory = this.report_lang === 'ko' ? target_audit_category?.category : this.report_lang === 'en' ? target_audit_category?.category_ea : target_audit_category?.category_ca;
                        }
                        
                        tableBody.push([
                            {
                                content: '',
                                ev_code,
                                styles: {...tdStyle },
                            },
                            {
                                content: evName,
                                styles: {...tdStyle, halign: evName === '-' ? 'center' : 'left'  },
                                colSpan: isNonCompliance ? 1 : 2,
                            },
                            {
                                content: evItem.audit_category_code === 'EV_AUTO' ? '-' : auditCategory,
                                colSpan: evItem.audit_category_code === 'EV_AUTO' ? 2 : 1,
                                styles: {...tdStyle },
                            },
                            {
                                content: evComment,
                                styles: {...tdStyle, halign: evComment === '-' ? 'center' : 'left' },
                            }
                        ]);
                        if(isNonCompliance){
                            tableBody[tableBody.length -1].splice(2, 0, {
                                content: '',
                                styles: {...tdStyle, cellWidth: 16 },
                                data: {
                                    ev_id, subCode, code,
                                },
                                type: 'link'
                            } );
                        }
                    });
                    
                    let leftCellWidth = this.pageContentWidth * 0.5;
                    const rightCellWidth = this.pageContentWidth * 0.5;
                    
                    const columnStyles = [
                        { cellWidth: 24 },
                        { cellWidth: leftCellWidth - 40 },
                        { cellWidth: 16 },
                        { cellWidth: 60 },
                        { cellWidth: rightCellWidth - 60 }
                    ];
                    
                    autoTable(doc, {
                        theme: 'grid',
                        startY: position_y,
                        margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing - 5, bottom: 45},
                        tableWidth: this.pageContentWidth,
                        columnStyles:columnStyles,
                        pageBreak: 'auto',
                        rowPageBreak: 'avoid',
                        body: tableBody,
                        willDrawCell: (data) => {
                            if (data.section === 'body') {
                                const {cell} = data;
                                
                                if (cell.raw?.ev_code != null) {
                                    cell.text = [];
                                }
                            }
                        },
                        didDrawCell: (data) => {
                            // 첫 번째 열(수준)이고 헤더가 아닌 경우
                            if (data.column.index === 0 && data.row.index > 0) {
                                const doc = data.doc;
                                const ev_code = data.cell.raw.ev_code; // 'D', 'C', 'B', 'A'
                                
                                // 원형 태그 위치 계산
                                const circleRadius = 3;
                                const circleX = data.cell.x + data.cell.width / 2;
                                const circleY = data.cell.y + data.cell.height / 2;
                                
                                // 원형 배경 (border 없음)
                                doc.setLineWidth(0);
                                doc.setFillColor(...this.ksteel_colors.state[ev_code]);
                                doc.circle(circleX, circleY, circleRadius, 'F');
                            }
                            if (data.column.index === 2 && data.row.index > 0 && data.cell.raw?.type === 'link') {
                                const {cell} = data;
                                const {ev_id} = cell.raw.data;
                                const doc = data.doc;
                                const iconSize = 8;
                                const iconX = data.cell.x + (data.cell.width - iconSize) / 2;
                                const iconY = data.cell.y + (data.cell.height - iconSize) / 2;
                                
                                doc.addImage(ShortcutIcon, 'SVG', iconX, iconY, iconSize, iconSize);
                                
                                let positionY = cell.y - 60;
                                if(cell.y - 60 < this.jsPDFOpt.margin.top){
                                    positionY = this.jsPDFOpt.margin.top;
                                }
                                this.linkDestinationInfo.toAppendix[ev_id].linkDestination = {
                                    pageNumber: doc.internal.getCurrentPageInfo().pageNumber,
                                    y: positionY
                                };
                                this.linkDestinationInfo.toImprovement[ev_id].linkSource = {
                                    pageNumber: doc.internal.getCurrentPageInfo().pageNumber,
                                    x: cell.x,
                                    y: cell.y,
                                    width: cell.width,
                                    height: cell.height
                                };
                            }
                        },
                        didDrawPage: (HookData) => {
                            this.addHeader(HookData.doc);
                        },
                    });
                   
                    if(isSubNonCompliance){
                        position_y = doc.lastAutoTable.finalY + 6;
                        
                        let baseGuideXPos = leftStart + this.pageContentWidth;
                        const iconSize = 8;
                        const iconY = position_y - 4;
                        this.setFont(doc, 'table_td', null, 'normal');
                        doc.setTextColor('#666666');
                        doc.setFontSize(8.5);
                        const iconDescText = `: ${this.$t('클릭 시, 해당 평가 요소의 개선 권고사항을 확인하실 수 있습니다.', this.report_lang)}`;
                        const iconDescMsg = doc.splitTextToSize(iconDescText, this.pageContentWidth);
                        baseGuideXPos -= doc.getTextDimensions(iconDescMsg).w;
                        doc.text(iconDescText, baseGuideXPos, position_y + 3);
                        baseGuideXPos += - iconSize - 2;
                        doc.addImage(ShortcutIcon, 'SVG', baseGuideXPos, iconY, iconSize, iconSize);
                        
                        position_y += 12 + this.jsPDFOpt.spacing.section_xs;
                    }
                    else {
                        position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
                    }
                        
                    if(idx !== entriesTargetCodeEvData.length - 1 || !checkLast) {
                        if (this.checkNeedNewPage(doc, position_y, 70)) {
                            this.addDocPage(doc, true);
                            this.addHeader(doc);
                            position_y = this.firstElementSpacing;
                        }
                    }
                });
            }
            
            ['toAppendix', 'toImprovement'].forEach((key) => {
                Object.values(this.linkDestinationInfo[key]).forEach(({linkSource, linkDestination}) => {
                    if (linkSource && linkDestination) {
                        // 링크를 그려야 할 출발지 페이지로 다시 이동
                        doc.setPage(linkSource.pageNumber);
                        
                        // 저장해둔 정보를 바탕으로 링크 생성
                        doc.link(
                            linkSource.x,
                            linkSource.y,
                            linkSource.width,
                            linkSource.height,
                            {
                                pageNumber: linkDestination.pageNumber,
                                top: linkDestination.y
                            }
                        );
                    }
                });
            });
            
            return position_y;
        },
        async codeResult_summary(doc, position_y, cate3) {
            const leftStart = this.jsPDFOpt.margin.left;
            const codeTextCardYPos = position_y + 4;
            doc.setDrawColor('#c2bfbf');
            doc.setLineWidth(1);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(leftStart, codeTextCardYPos, this.pageContentWidth, 30, 'FD');
            
            doc.setLineWidth(0);
            doc.setFillColor(this.ksteel_colors.muted);
            const codeTagXPos = leftStart + 6;
            doc.roundedRect(codeTagXPos, codeTextCardYPos + 6, 40, 19, 4, 4, 'F');
            
            const code = cate3.category3_question_name.split('.')[0];
            this.setFont(doc, 'table_td', null, 'bold');
            doc.setFontSize(15);
            doc.setTextColor('#ffffff');
            doc.text(code, codeTagXPos + 20, codeTextCardYPos + 20, {align: 'center'});
            
            const codeConductXPos = codeTagXPos + 40 + 8;
            let codeConductYPos = codeTextCardYPos + 19;
            doc.setTextColor('#232323');
            doc.setFontSize(13);
            
            let codeConductText = doc.splitTextToSize(codeResult.mapCodeToConduct[code], this.pageContentWidth - codeConductXPos + 24);
            if (codeConductText.length > 1) {
                doc.setFontSize(12);
                codeConductText = doc.splitTextToSize(codeResult.mapCodeToConduct[code], this.pageContentWidth - codeConductXPos + 24);
                if (codeConductText.length > 1) {
                    codeConductYPos -= 6;
                }
            }
            doc.text(codeConductText, codeConductXPos, codeConductYPos, {align: 'left'});
            
            
            const conductDescCardYPos = position_y + 44;
            this.setFont(doc, 'table_td', null, 'normal');
            doc.setTextColor('#232323');
            doc.setFontSize(10.5);
            
            const conductDescMsg = doc.splitTextToSize(codeResult.mapCodeToConductDesc[code], this.pageContentWidth - 10);
            const conductDescMsgDim = doc.getTextDimensions(conductDescMsg);
            const conductDescCardHeight = conductDescMsgDim.h + 16;
            
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.setDrawColor('#c2bfbf');
            doc.setLineWidth(0.5);
            doc.rect(leftStart, conductDescCardYPos, this.pageContentWidth, conductDescCardHeight, 'FD');
            doc.text(conductDescMsg, leftStart + 8, conductDescCardYPos + 14, {align: 'left'});
            
            position_y += conductDescCardHeight + 50;
            
            position_y = this.addTitle(doc, position_y + 2, 2, this.$t('코드별 평가', this.report_lang), {skip_divider: true});
            
            const codeResultCardYPos = position_y - 10;
            const codeResultCardHeight = 62;
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(leftStart, codeResultCardYPos, this.pageContentWidth, codeResultCardHeight, 'FD');
            
            const complianceLevelTextYPos = codeResultCardYPos + 18;
            doc.text(this.$t('준수 수준', this.report_lang), leftStart + 12, complianceLevelTextYPos, {align: 'left'});
            
            doc.setDrawColor('#c2bfbf');
            doc.setLineWidth(1);
            doc.setFillColor(...this.ksteel_colors.state[cate3.category3_ev_code ?? 'N'] );
            const codeLevelTagXPos = leftStart + 22;
            const codeLevelTagYPos = complianceLevelTextYPos + 8;
            doc.roundedRect(codeLevelTagXPos, codeLevelTagYPos, 58, 24, 4, 4, 'FD');
            
            this.setFont(doc, 'table_td', null, 'bold');
            doc.setTextColor('#ffffff');
            if (cate3.category3_ev_code === 'B' || cate3.category3_ev_code === 'C') {
                doc.setTextColor('#232323');
            }
            doc.setFontSize(16);
            const targetCodeLevelDesc = this.reportData.ev_code_list.find(item => item.code === (cate3.category3_ev_code ?? 'N')).description;
            const codeLevelDescText = doc.splitTextToSize(this.$t(targetCodeLevelDesc, this.report_lang), this.pageContentWidth);
            const codeLevelDescTextDim = doc.getTextDimensions(codeLevelDescText);
            const codeLevelDescTextXPos = codeLevelTagXPos + (58 - codeLevelDescTextDim.w) / 2;
            doc.text(codeLevelDescText, codeLevelDescTextXPos, codeLevelTagYPos + 17, {align: 'left'});
            
            doc.setLineWidth(0.75);
            doc.setDrawColor('#E0E0E0');
            const lineXPos = 128;
            const lineYPosBegin = codeResultCardYPos + 8;
            doc.line(lineXPos, lineYPosBegin, lineXPos, lineYPosBegin + codeResultCardHeight - 16);
            
            const codeLevelGuideMsg = doc.splitTextToSize(codeResult.mapCodeComplianceMsg({
                company_name: this.companyInfo['회사명'],
                code,
                ev_code_desc: targetCodeLevelDesc,
                ev_code: cate3.category3_ev_code ?? 'N',
                code_desc: cate3.category3_question_name,
            }), this.pageContentWidth - 14);
            const codeLevelGuideMsgDim = doc.getTextDimensions(codeLevelGuideMsg);
            const codeLevelGuideMsgYPos = lineYPosBegin + (codeResultCardHeight - 16 - codeLevelGuideMsgDim.h) / 2 + 4;
            
            this.setFont(doc, 'table_td', null, 'normal');
            doc.setTextColor('#232323');
            doc.setFontSize(11);
            doc.text(codeLevelGuideMsg, lineXPos + 16, codeLevelGuideMsgYPos + 10, {align: 'left'});
            
            position_y += codeResultCardHeight;
            
            return position_y;
        },
        async codeResult_scoreCard(doc, position_y, cate3) {
            const code = cate3.category3_question_name.split('.')[0];
            
            const cellWidth = this.pageContentWidth / 4;
            const codeStyle = {
                ...this.tableStyles.th,
                lineColor: '#232323',
                cellWidth,
                halign: 'center',
                fontStyle: 'bold',
                lineWidth: 1
            };
            let tableBody = [];
            
            if (cate3.category3_ev_code === 'N') {
                tableBody = [
                    [
                        {
                            content: this.$t('매우 미흡', this.report_lang),
                            styles: {...codeStyle, fillColor: this.ksteel_colors.muted, textColor: '#ffffff'}
                        },
                        {
                            content: this.$t('미흡 ', this.report_lang),
                            styles: {...codeStyle, fillColor: this.ksteel_colors.muted, textColor: '#ffffff'}
                        },
                        {
                            content: this.$t('보통', this.report_lang),
                            styles: {...codeStyle, fillColor: this.ksteel_colors.muted, textColor: '#ffffff'}
                        },
                        {
                            content: this.$t('우수', this.report_lang),
                            styles: {...codeStyle, fillColor: this.ksteel_colors.muted, textColor: '#ffffff'}
                        },
                    ],
                    [
                        {
                            content: codeResult.mapCodeLevelDesc[code].D,
                            styles: {...codeStyle, fontStyle: 'medium', fontSize: 10, halign: 'left', fillColor: '#bebebe'}
                        },
                        {
                            content: codeResult.mapCodeLevelDesc[code].C,
                            styles: {...codeStyle, fontStyle: 'medium', fontSize: 10, halign: 'left', fillColor: '#bebebe'}
                        },
                        {
                            content: codeResult.mapCodeLevelDesc[code].B,
                            styles: {...codeStyle, fontStyle: 'medium', fontSize: 10, halign: 'left', fillColor: '#bebebe'}
                        },
                        {
                            content: codeResult.mapCodeLevelDesc[code].A,
                            styles: {...codeStyle, fontStyle: 'medium', fontSize: 10, halign: 'left', fillColor: '#bebebe'}
                        },
                    ],
                ];
                
                if (codeResult.mapCodeLevelDesc[code].A === '-') {
                    tableBody[1][3].styles.halign = 'center';
                }
            } 
            else {
                tableBody = [
                    [
                        {
                            content: this.$t('매우 미흡', this.report_lang),
                            styles: {...codeStyle, fillColor: this.ksteel_colors.state.D, textColor: '#ffffff'}
                        },
                        {
                            content: this.$t('미흡 ', this.report_lang),
                            styles: {...codeStyle, fillColor: this.ksteel_colors.state.C}
                        },
                        {
                            content: this.$t('보통', this.report_lang),
                            styles: {...codeStyle, fillColor: this.ksteel_colors.state.B}
                        },
                        {
                            content: this.$t('우수', this.report_lang),
                            styles: {...codeStyle, fillColor: this.ksteel_colors.state.A, textColor: '#ffffff'}
                        },
                    ],
                    [
                        {
                            content: codeResult.mapCodeLevelDesc[code].D,
                            styles: {
                                ...codeStyle,
                                fontStyle: 'medium',
                                halign: 'left',
                                fontSize: 10,
                                fillColor: rgbaToRgb([...this.ksteel_colors.state.D, 0.5])
                            }
                        },
                        {
                            content: codeResult.mapCodeLevelDesc[code].C,
                            styles: {
                                ...codeStyle,
                                fontStyle: 'medium',
                                halign: 'left',
                                fontSize: 10,
                                fillColor: rgbaToRgb([...this.ksteel_colors.state.C, 0.5])
                            }
                        },
                        {
                            content: codeResult.mapCodeLevelDesc[code].B,
                            styles: {
                                ...codeStyle,
                                fontStyle: 'medium',
                                halign: 'left',
                                fontSize: 10,
                                fillColor: rgbaToRgb([...this.ksteel_colors.state.B, 0.5])
                            }
                        },
                        {
                            content: codeResult.mapCodeLevelDesc[code].A,
                            styles: {
                                ...codeStyle,
                                fontStyle: 'medium',
                                halign: 'left',
                                fontSize: 10,
                                fillColor: rgbaToRgb([...this.ksteel_colors.state.A, 0.5])
                            }
                        },
                    ],
                ];
                
                if (codeResult.mapCodeLevelDesc[code].A === '-') {
                    tableBody[0][3].styles.fillColor = this.ksteel_colors.muted;
                    tableBody[1][3].styles.fillColor = '#bebebe';
                    tableBody[1][3].styles.halign = 'center';
                }
            }
            
            autoTable(doc, {
                theme: 'grid',
                startY: position_y + 4,
                margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing - 5},
                tableWidth: this.pageContentWidth,
                pageBreak: 'auto',
                rowPageBreak: 'avoid',
                styles: {
                    ...this.tableStyles.global,
                    lineWidth: 0
                },
                body: tableBody,
                didDrawPage: (hookData) => {
                    if(cate3.category3_ev_code === 'N') return;
                    
                    const firstCellX = this.jsPDFOpt.margin.left;
                    const cellWidth = this.pageContentWidth / 4;
                    const gradeToColIndex = { D: 0, C: 1, B: 2, A: 3 };
                    
                    const targetColIndex = gradeToColIndex[cate3.category3_ev_code];
                    const targetBoxX = firstCellX + (cellWidth * targetColIndex);
                    let tableHeight = 0;
                    hookData.table.body.forEach(row => {
                        tableHeight += row.height;
                    });
                    // 현재 준수 수준에 박스
                    doc.setDrawColor(this.ksteel_colors.selected);
                    doc.setLineWidth(3);
                    doc.rect(targetBoxX - 0.5, hookData.settings.startY,  cellWidth + 0.5, tableHeight, 'S');
                    
                }
            });
            return doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
        },
        async codeResult_nonComplianceDetail(doc, position_y, cate3) {
            const titleMsg = doc.splitTextToSize(this.$t('문항별 주요 개선 필요 항목', this.report_lang), this.pageContentWidth);
            const titleDim = doc.getTextDimensions(titleMsg);
            position_y = this.addTitle(doc, position_y, 2, titleMsg, {skip_divider: true});
            
            const leftStart = this.jsPDFOpt.margin.left;
            let lineXPos = leftStart + titleDim.w + 24;
            const lineYPos = position_y - 18;
            if(this.report_lang === 'ko'){
                doc.setLineWidth(1);
                doc.setDrawColor('#343a40');
                doc.line(lineXPos, lineYPos, this.pageContentWidth + leftStart, lineYPos);
            }
            
            
            const code = cate3.category3_question_name.split('.')[0];
            const targetCodeEvData =  this.evBaseData.processedEvData[code];
            
            const codeEvDataObjList = Object.entries(targetCodeEvData).filter(([subCode]) => {
                const targetSub = this.subBaseData.mapSubCodeData[subCode];
                return targetSub.ev_code === 'C' || targetSub.ev_code === 'D';
            });
            
            if(codeEvDataObjList.length < 1){
                const emptyCardYPos = position_y - 4;
                doc.setDrawColor('#c2bfbf');
                doc.setLineWidth(0.6);
                doc.setFillColor(...rgbaToRgb([...this.ksteel_colors.state.N, 0.25]));
                doc.rect(leftStart, emptyCardYPos, this.pageContentWidth, 80, 'FD');
                this.setFont(doc, 'table_td', null, 'medium');
                doc.setFontSize(11);
                doc.setTextColor('#666666');
                doc.text(this.$t('코드 요구사항 준수하여, 주요 개선 필요 항목 없음', this.report_lang), leftStart + this.pageContentWidth / 2, emptyCardYPos + 40, {align: 'center'});
                
                return position_y;
            }
            else {
                this.setFont(doc, 'table_td', null, 'normal');
                doc.setTextColor('#666666');
                doc.setFontSize(11);
                const basicGuideMsg = doc.splitTextToSize(this.$t('nonComplianceGuideMsg' , this.report_lang, {code: code}), this.pageContentWidth);
                doc.text(basicGuideMsg, leftStart, position_y + 2, {align: 'left'});
                
                position_y += doc.getTextDimensions(basicGuideMsg).h + 10;
            }
            
            codeEvDataObjList.forEach(([subCode, evItems]) => {
                if (this.checkNeedNewPage(doc, position_y, 80)) {
                    this.addDocPage(doc, true);
                    position_y = this.firstElementSpacing;
                }
                const targetSub = this.subBaseData.mapSubCodeData[subCode];
                // subLabel
                this.setFont(doc, 'table_td', null, 'medium');
                doc.setTextColor('#232323');
                doc.setFontSize(11);
                const subLabelPosY = position_y + 4;
                doc.text(this.$t('문항 ', this.report_lang) + targetSub.label + ':', leftStart, subLabelPosY, {align: 'left'});
                
                position_y += 8;
                
                const thStyle = {
                    ...this.tableStyles.th,
                    lineColor: '#232323',
                    halign: 'center',
                    fontStyle: 'bold',
                };
                

                const tableBody = [
                    [
                        {
                            content: this.$t('평가 결과', this.report_lang),
                            colSpan: 3,
                            styles: {...thStyle }
                        },
                        {
                            content: this.$t('개선 권고사항', this.report_lang),
                            styles: {...thStyle }
                        },
                    ]
                ];
                
                Object.entries(evItems).forEach(([ev_id, evItem]) => {
                    if(ev_id === 'isNA') return;
                    const ev_code = evItem.ev_code;
                    
                    if(ev_code === 'A' || ev_code === 'B' || ev_code === 'N' || ev_code == null) return;
                    
                    
                    const tdStyle = {
                        ...this.tableStyles.td,
                        lineColor: '#232323',
                        halign: 'center',
                        fontStyle: 'normal',
                    }; 
                    
                    
                    tableBody.push([
                        {
                            content: '',
                            ev_code,
                            styles: {...tdStyle },
                        },
                        {
                            content: codeResult.evAsIsToBeMsg[ev_id].asIs,
                            styles: {...tdStyle, halign: 'left', },
                        },
                        {
                            content: '',
                            data: {
                                code,
                                subCode,
                                ev_id,  
                            },
                            styles: {...tdStyle },
                        },
                        {
                            content: codeResult.evAsIsToBeMsg[ev_id].toBe,
                            styles: {...tdStyle, halign: 'left', },
                        },
                    ]);
                        
                });
                
                const leftCellWidth = this.pageContentWidth * 0.57;
                let auditBasisWidth = 16;
                autoTable(doc, {
                    theme: 'grid',
                    startY: position_y,
                    margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing - 5},
                    tableWidth: this.pageContentWidth,
                    columnStyles: {
                        0: { cellWidth: 40 },
                        1: { cellWidth: leftCellWidth - 40 - auditBasisWidth },
                        2: { cellWidth: auditBasisWidth },
                        3: { cellWidth: this.pageContentWidth - leftCellWidth }
                    },
                    pageBreak: 'auto',
                    rowPageBreak: 'avoid',
                    body: tableBody,
                    willDrawCell: (data) => {
                        if (data.section === 'body') {
                            const {cell} = data;
                            
                            if (cell.raw?.ev_code != null) {
                                cell.text = [];
                            }
                        }
                    },
                    didDrawCell: (data) => {
                        if (data.column.index === 0 && data.row.index > 0) {
                            const doc = data.doc;
                            const ev_code = data.cell.raw.ev_code;
                            
                            // 태그 위치 계산
                            const tagWidth = 32;
                            const tagHeight = 11;
                            const tagX = data.cell.x + (data.cell.width - tagWidth) / 2;
                            const tagY = data.cell.y + (data.cell.height - tagHeight) / 2;
                            
                            // 태그 배경
                            doc.setDrawColor('#c2bfbf');
                            doc.setLineWidth(1);
                            doc.setFillColor(...this.ksteel_colors.state[ev_code]);
                            doc.roundedRect(tagX, tagY, tagWidth, tagHeight, 4, 4, 'FD');
                            
                            // 태그 텍스트
                            this.setFont(doc, 'table_td', null, 'bold');
                            doc.setFontSize(8.5);
                            doc.setTextColor('#ffffff');
                            if (ev_code === 'B' || ev_code === 'C') {
                                doc.setTextColor('#232323');
                            }
                            
                            const targetLevelDesc = this.reportData.ev_code_list.find(item => item.code === ev_code).description;
                            const levelText = this.$t(targetLevelDesc, this.report_lang);
                            const textDim = doc.getTextDimensions(levelText);
                            const textX = tagX + (tagWidth - textDim.w) / 2;
                            const textY = tagY + tagHeight / 2 + textDim.h / 2 - 1;
                            doc.text(levelText, textX, textY);
                        }
                        if (data.column.index === 2 && data.row.index > 0) {
                            const {cell} = data;
                            const doc = data.doc;
                            const iconSize = 8;
                            const iconX = data.cell.x + (data.cell.width - iconSize) / 2;
                            const iconY = data.cell.y + (data.cell.height - iconSize) / 2;
                            
                            doc.addImage(ShortcutIcon, 'SVG', iconX, iconY, iconSize, iconSize);
                            const {ev_id} = cell.raw.data;
                            
                            this.linkDestinationInfo.toAppendix[ev_id] = {
                                linkSource: {
                                    pageNumber: doc.internal.getCurrentPageInfo().pageNumber,
                                    x: cell.x,
                                    y: cell.y,
                                    width: cell.width,
                                    height: cell.height
                                },
                                linkDestination: {}
                            };
                            let positionY = cell.y - 60;
                            if(cell.y - 60 < this.jsPDFOpt.margin.top){
                                positionY = this.jsPDFOpt.margin.top;
                            }
                            this.linkDestinationInfo.toImprovement[ev_id] = {
                                linkSource: {},
                                linkDestination: {
                                    pageNumber: doc.internal.getCurrentPageInfo().pageNumber,
                                    y: positionY
                                }
                            };
                        }
                    },
                    didDrawPage: (HookData) => {
                        this.addHeader(HookData.doc);
                    },
                });
                position_y = doc.lastAutoTable.finalY + 6;
                
                let baseXPos = leftStart + this.pageContentWidth;
                const iconSize = 8;
                const iconY = position_y - 4;
                this.setFont(doc, 'table_td', null, 'normal');
                doc.setTextColor('#666666');
                doc.setFontSize(8.5);
                const iconDescText = `: ${this.$t('클릭 시, Appendix의 해당 페이지에서 개선 필요 항목으로 평가된 상세 근거를 확인하실 수 있습니다.', this.report_lang)}`;
                const iconDescMsg = doc.splitTextToSize(iconDescText, this.pageContentWidth);
                baseXPos -= doc.getTextDimensions(iconDescMsg).w;
                doc.text(iconDescText, baseXPos, position_y + 3);
                baseXPos += - iconSize - 2;
                doc.addImage(ShortcutIcon, 'SVG', baseXPos, iconY, iconSize, iconSize);
                
                position_y += 12 + this.jsPDFOpt.spacing.section_xs;
            }); 
            return position_y;
        },
        async codeSummary_AreaCompliance(doc, position_y) {
            const [humanRight, environment, governance] = this.levelData.category1;
            
            let chartCount = 0;
            [humanRight, environment, governance].forEach((item) => {
                if(item != null)
                    chartCount += 1;
            });
            
            if(chartCount === 1) // 사내 도급의 경우 Area 영역 필요 없음
                return position_y;
            
            position_y = this.addTitle(doc, position_y, 1, this.$t('영역별 준수율', this.report_lang));
            
            const chartWidth = 100;
            let chartPadding = (this.pageContentWidth - chartWidth * chartCount) / 2;
            
            if(chartCount === 2){
                chartPadding = (this.pageContentWidth - chartWidth * chartCount) / 3;
            }
            
            let chartXPos = this.jsPDFOpt.margin.left;
            let labelPosY = position_y + 12;
            
            this.setFont(doc, 'table_td', null, 'semibold');
            doc.setTextColor(29, 29, 29);
            doc.setFontSize(14);
            
            
            // 인권 차트
            if(chartCount < 3){
                chartXPos += chartPadding;
            }
            const humanRightText = doc.splitTextToSize(this.$t('인권', this.report_lang), this.pageContentWidth);
            const humanRightTextDim = doc.getTextDimensions(humanRightText);
            const humanRightTextXPos = chartXPos + (chartWidth - humanRightTextDim.w) / 2;
            doc.text(humanRightText, humanRightTextXPos, labelPosY);
            
            const compliance = humanRight.category1_compliance_rate === 'N/A' ? 0 : humanRight.category1_compliance;
            const nonCompliance = humanRight.category1_compliance_rate === 'N/A' ? 100 : humanRight.category1_noncompliance;
            const nonComplianceColor = humanRight.category1_compliance_rate === 'N/A' ? this.ksteel_colors.muted : this.ksteel_colors.nonCompliance;
            
            const humanRightChart = await this.generateCodeSummaryPieChartInstance(
                [compliance, nonCompliance],
                {data1: this.ksteel_colors.compliance, data2: nonComplianceColor},
            );
            await waitTime(100);
            doc.addImage(humanRightChart, 'PNG', chartXPos, labelPosY + 12, chartWidth, chartWidth, undefined, 'FAST');
            this.codeDoughnutChartInstance?.destroy();
            this.codeDoughnutChartInstance = null;
            
            doc.setFontSize(24);
            const complianceRate = humanRight.category1_compliance_rate === 'N/A' ? 'N/A' :  this.roundToOneDecimalPlace(humanRight.category1_compliance_rate) + '%';
            const humanRightPercent = doc.splitTextToSize(complianceRate, this.pageContentWidth);
            const humanRightPercentDim = doc.getTextDimensions(humanRightPercent);
            const humanRightPercentXPos = chartXPos + (chartWidth - humanRightPercentDim.w) / 2;
            const humanRightPercentYPos = labelPosY + 12 + (chartWidth + humanRightPercentDim.h) / 2;
            doc.text(humanRightPercent, humanRightPercentXPos, humanRightPercentYPos);
            
            chartXPos += chartWidth + chartPadding;
            
            if(chartCount > 1){
                // 환경 차트
                doc.setFontSize(14);
                const environmentText = doc.splitTextToSize(this.$t('환경', this.report_lang), this.pageContentWidth);
                const environmentTextDim = doc.getTextDimensions(environmentText);
                const environmentTextXPos = chartXPos + (chartWidth - environmentTextDim.w) / 2;
                doc.text(environmentText, environmentTextXPos, labelPosY);
                
                const compliance = environment.category1_compliance_rate === 'N/A' ? 0 : environment.category1_compliance;
                const nonCompliance = environment.category1_compliance_rate === 'N/A' ? 100 : environment.category1_noncompliance;
                const nonComplianceColor = environment.category1_compliance_rate === 'N/A' ? this.ksteel_colors.muted : this.ksteel_colors.nonCompliance;
                
                const environmentChart = await this.generateCodeSummaryPieChartInstance(
                    [compliance, nonCompliance],
                    {data1: this.ksteel_colors.compliance, data2: nonComplianceColor},
                );
                await waitTime(100);
                doc.addImage(environmentChart, 'PNG', chartXPos, labelPosY + 12, chartWidth, chartWidth, undefined, 'FAST');
                this.codeDoughnutChartInstance?.destroy();
                this.codeDoughnutChartInstance = null;
                
                doc.setFontSize(24);
                const complianceRate = environment.category1_compliance_rate === 'N/A' ? 'N/A' :  this.roundToOneDecimalPlace(environment.category1_compliance_rate) + '%';
                const environmentPercent = doc.splitTextToSize(complianceRate, this.pageContentWidth);
                const environmentPercentDim = doc.getTextDimensions(environmentPercent);
                const environmentPercentXPos = chartXPos + (chartWidth - environmentPercentDim.w) / 2;
                const environmentPercentYPos = labelPosY + 12 + (chartWidth + environmentPercentDim.h) / 2;
                doc.text(environmentPercent, environmentPercentXPos, environmentPercentYPos);
                
                chartXPos += chartWidth + chartPadding;
            }
            
            if(chartCount > 2){
                // 거버넌스 차트
                doc.setFontSize(14);
                const governanceText = doc.splitTextToSize(this.$t('거버넌스', this.report_lang), this.pageContentWidth);
                const governanceTextDim = doc.getTextDimensions(governanceText);
                const governanceTextXPos = chartXPos + (chartWidth - governanceTextDim.w) / 2;
                doc.text(governanceText, governanceTextXPos, labelPosY);
                
                const compliance = governance.category1_compliance_rate === 'N/A' ? 0 : governance.category1_compliance;
                const nonCompliance = governance.category1_compliance_rate === 'N/A' ? 100 : governance.category1_noncompliance;
                const nonComplianceColor = governance.category1_compliance_rate === 'N/A' ? this.ksteel_colors.muted : this.ksteel_colors.nonCompliance;
                
                const governanceChart = await this.generateCodeSummaryPieChartInstance(
                    [compliance, nonCompliance],
                    {data1: this.ksteel_colors.compliance, data2: nonComplianceColor},
                );
                await waitTime(100);
                doc.addImage(governanceChart, 'PNG', chartXPos, labelPosY + 12, chartWidth, chartWidth, undefined, 'FAST');
                this.codeDoughnutChartInstance?.destroy();
                this.codeDoughnutChartInstance = null;
                
                doc.setFontSize(24);
                const complianceRate = governance.category1_compliance_rate === 'N/A' ? 'N/A' :  this.roundToOneDecimalPlace(governance.category1_compliance_rate) + '%';
                const governancePercent = doc.splitTextToSize(complianceRate, this.pageContentWidth);
                const governancePercentDim = doc.getTextDimensions(governancePercent);
                const governancePercentXPos = chartXPos + (chartWidth - governancePercentDim.w) / 2;
                const governancePercentYPos = labelPosY + 12 + (chartWidth + governancePercentDim.h) / 2;
                doc.text(governancePercent, governancePercentXPos, governancePercentYPos);
            }
           
            
            
            
            position_y += (chartWidth + this.jsPDFOpt.spacing.section_xs + 40);
            
            return position_y;
        },
        async codeSummary_CodeCompliance(doc, position_y) {
            position_y = this.addTitle(doc, position_y, 1, this.$t('Code별 준수결과', this.report_lang));
            
            const category1Data = JSON.parse(JSON.stringify(this.reportData.results[2].data));
            const category2Data = JSON.parse(JSON.stringify(this.reportData.results[3].data));
            const category3Data = JSON.parse(JSON.stringify(this.reportData.results[4].data));
            const thStyle = {...this.tableStyles.th, lineColor: '#232323', fontSize: 11 };
            
            const tableBody = [
                [
                    {
                        content: this.$t('대분류', this.report_lang),
                        styles: {...thStyle, cellWidth: 50, halign: 'center'}
                    },
                    {
                        content: this.$t('중분류', this.report_lang),
                        styles: {...thStyle, cellWidth: 50, halign: 'center'}
                    },
                    {
                        content: this.$t('Code', this.report_lang),
                        styles: {...thStyle, halign: 'center'}
                    },
                    {
                        content: this.$t('매우미흡', this.report_lang),
                        styles: {...thStyle, cellWidth: 25, halign: 'center'}
                    },
                    {
                        content: this.$t('미흡', this.report_lang),
                        styles: {...thStyle, cellWidth: 25, halign: 'center'}
                    },
                    {
                        content: this.$t('보통', this.report_lang),
                        styles: {...thStyle, cellWidth: 25, halign: 'center'}
                    },
                    {
                        content: this.$t('우수', this.report_lang),
                        styles: {...thStyle, cellWidth: 25, halign: 'center'}
                    },
                ]
            ];
            
            const scoreCnt = {
                'A': 0,
                'B': 0,
                'C': 0,
                'D': 0,
            };
            let currentTarget = {
                cat1: null,
                cat2: null,
            };
            category3Data.forEach((category3, cate3Idx) => {
                tableBody.push([]);
                let cateIdx = tableBody.length - 1;
                
                const code = category3.category3_question_name.split('.')[0];
                
                const targetCat1 = category1Data.find(cat1 => {
                    const currentCat1Code = code.split('-')[0];
                    return cat1.category1_question_name.split('.')[0] === currentCat1Code;
                });
                if (currentTarget.cat1?.category1_question_code !== targetCat1.category1_question_code) {
                    currentTarget.cat1 = targetCat1;
                    
                    const rowSpan = category3Data.filter(cat3 => {
                        return cat3.category3_question_name.includes(targetCat1.category1_question_name.split('.')[0]);
                    }).length;
                    
                    tableBody[cateIdx].push(
                        {
                            content: targetCat1.category1_question_name,
                            rowSpan,
                            styles: {
                                ...this.tableStyles.td,
                                fontSize: 10.5,
                                fontStyle: 'bold',
                                textColor: '#292828',
                                halign: 'center'
                            }
                        },
                    );
                }
                
                const targetCat2 = category2Data.find(cat2 => {
                    const codeSplit = code.split('-');
                    const currentCat2Code = `${codeSplit[0]}-${codeSplit[1]}`;
                    return cat2.category2_question_name.split('.')[0] === currentCat2Code;
                });
                
                
                if (currentTarget.cat2?.category2_question_code !== targetCat2.category2_question_code) {
                    currentTarget.cat2 = targetCat2;
                    
                    const rowSpan = category3Data.filter(cat3 => {
                        return cat3.category3_question_name.includes(targetCat2.category2_question_name.split('.')[0]);
                    }).length;
                    
                    tableBody[cateIdx].push({
                        content: targetCat2.category2_question_name,
                        rowSpan,
                        styles: {
                            ...this.tableStyles.td,
                            fontSize: 10,
                            fontStyle: 'semibold',
                            halign: 'left',
                            textColor: '#292828'
                        },
                        
                    });
                }
                
                tableBody[cateIdx].push({
                    content: `${code}. ${codeResult.mapCodeToConduct[code]}`, styles: {...this.tableStyles.td, fontSize: 9,minCellHeight: 20,   halign: 'left'},
                });
                
                if (category3.category3_ev_code === 'N' || category3.category3_ev_code == null) {
                    tableBody[cateIdx].push({
                        content: '', styles: {...this.tableStyles.td, fillColor: '#bebebe', halign: 'center'},
                    });
                    tableBody[cateIdx].push({
                        content: '', styles: {...this.tableStyles.td, fillColor: '#bebebe', halign: 'center'},
                    });
                    tableBody[cateIdx].push({
                        content: '', styles: {...this.tableStyles.td, fillColor: '#bebebe', halign: 'center'},
                    });
                    tableBody[cateIdx].push({
                        content: '', styles: {...this.tableStyles.td, fillColor: '#bebebe', halign: 'center'},
                    });
                } else {
                    tableBody[cateIdx].push({
                        content: '',
                        styles: {
                            ...this.tableStyles.td,
                            fillColor: category3.category3_ev_code === 'D' ? this.ksteel_colors.state.D : '#ffffff'
                        },
                    });
                    tableBody[cateIdx].push({
                        content: '',
                        styles: {
                            ...this.tableStyles.td,
                            fillColor: category3.category3_ev_code === 'C' ? this.ksteel_colors.state.C : '#ffffff'
                        },
                    });
                    tableBody[cateIdx].push({
                        content: '',
                        styles: {
                            ...this.tableStyles.td,
                            fillColor: category3.category3_ev_code === 'B' ? this.ksteel_colors.state.B : '#ffffff'
                        },
                    });
                    tableBody[cateIdx].push({
                        content: '',
                        styles: {
                            ...this.tableStyles.td,
                            fillColor: category3.category3_ev_code === 'A' ? this.ksteel_colors.state.A : '#ffffff'
                        },
                    });
                }
                
                scoreCnt[category3.category3_ev_code] += 1;
            });
            
            tableBody.push(
                [
                    {
                        content: 'TOTAL',
                        colSpan: 3,
                        styles: {
                            ...this.tableStyles.td,
                            fontSize: 11,
                            fontStyle: 'bold',
                            halign: 'center',
                            fillColor: '#666666',
                            textColor: '#ffffff'
                        }
                    },
                    {
                        content: scoreCnt.D.toString(),
                        styles: {
                            ...this.tableStyles.td,
                            fontSize: 11,
                            fontStyle: 'bold',
                            halign: 'center',
                            fillColor: '#666666',
                            textColor: '#ffffff'
                        }
                    },
                    {
                        content: scoreCnt.C.toString(),
                        styles: {
                            ...this.tableStyles.td,
                            fontSize: 11,
                            fontStyle: 'bold',
                            halign: 'center',
                            fillColor: '#666666',
                            textColor: '#ffffff'
                        }
                    },
                    {
                        content: scoreCnt.B.toString(),
                        styles: {
                            ...this.tableStyles.td,
                            fontSize: 11,
                            fontStyle: 'bold',
                            halign: 'center',
                            fillColor: '#666666',
                            textColor: '#ffffff'
                        }
                    },
                    {
                        content: scoreCnt.A.toString(),
                        styles: {
                            ...this.tableStyles.td,
                            fontSize: 11,
                            fontStyle: 'bold',
                            halign: 'center',
                            fillColor: '#666666',
                            textColor: '#ffffff'
                        }
                    },
                ]
            );
            
            this.setFont(doc, 'table_td', null);
            doc.setTextColor(100, 100, 100);
            doc.setFontSize(9);
            const naGuideMsg = doc.splitTextToSize(this.$t('해당 없음', this.report_lang), this.pageContentWidth);
            const naGuideMsgDim = doc.getTextDimensions(naGuideMsg);
            const naGuideMsgPosX = this.pageContentWidth + this.jsPDFOpt.margin.left - naGuideMsgDim.w;
            doc.text(naGuideMsg, naGuideMsgPosX, position_y + 2);
            
            doc.setLineWidth(0);
            doc.setFillColor('#bebebe');
            doc.rect(naGuideMsgPosX - 20, position_y - 4.5, 16, 8, 'FD');
            
            doc.text(this.$t('범례', this.report_lang) + ':', naGuideMsgPosX - 38, position_y + 2);
            
            autoTable(doc, {
                theme: 'grid',
                startY: position_y + 10,
                margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing - 5},
                tableWidth: this.pageContentWidth,
                pageBreak: 'auto',
                rowPageBreak: 'avoid',
                styles: {...this.tableStyles.global, lineWidth: 0.7, lineColor: '#232323'},
                body: tableBody,
                didDrawPage: (HookData) => {
                    this.addHeader(HookData.doc);
                }
            });
            
            return doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
        },
        
        summary_processCompanyInfo(doc, position_y) {
            // 기업정보 섹션
            position_y = this.addTitle(doc, position_y, 2, '기업 정보', {
                skip_divider: true,
                no_padding: true,
                no_margin: true
            });
            let _column_width = this.pageContentWidth / 4;
            
            const parseWorker = (worker_num) => {
                if (worker_num === ' - ') return 0;
                return Number(worker_num.toString().replaceAll(',', ''));
            };
            /**
             * @todo 근로자 계산식 통일 필요.
             */
            const worker_num = parseWorker(this.companyInfo['근로자수']);
            
            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: this.jsPDFOpt.margin,
                // styles: this.jsPDFOpt.tableOpt.common,
                styles: this.tableStyles.global,
                body: [
                    [
                        {
                            content: this.$t('기업명', this.report_lang),
                            styles: {...this.tableStyles.th, cellWidth: _column_width}
                        },
                        {content: this.companyInfo['회사명'], styles: {...this.tableStyles.td, cellWidth: _column_width * 3}},
                    ],
                    [
                        {
                            content: this.$t('기업규모', this.report_lang),
                            styles: {...this.tableStyles.th, cellWidth: _column_width}
                        },
                        {
                            content: this.companyInfo['기업규모'],
                            styles: {...this.tableStyles.td, cellWidth: _column_width * 3}
                        },
                    ],
                    [
                        {
                            content: this.$t('근로자수', this.report_lang),
                            styles: {...this.tableStyles.th, cellWidth: _column_width}
                        },
                        {
                            content: `${this.formatNumber(worker_num.toString())}${this.$t('명', this.report_lang)} (${this.$t('정규직', this.report_lang)}: ${this.formatNumber(this.companyInfo['근로자_정규직'])}, ${this.formatNumber(this.$t('계약직', this.report_lang))}: ${this.companyInfo['근로자_계약직']}, ${this.formatNumber(this.$t('일용직', this.report_lang))}: ${this.companyInfo['근로자_일용직']})`,
                            styles: {...this.tableStyles.td, cellWidth: _column_width * 3}
                        }
                    ],
                ],
                didDrawCell: (data) => this.jspdf_common_cell_font_convert(data)
            });
            
            
            position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
            
            // 평가정보 섹션
            position_y = this.addTitle(doc, position_y, 2, this.$t('평가 정보', this.report_lang), {
                skip_divider: true,
                no_padding: true,
                no_margin: true
            });
            let _column_width_1 = _column_width;
            let _column_width_2 = this.pageContentWidth - _column_width_1;
            
            const getFormattedDate = (date) => {
                if (!date) return ' - ';
                return this.report_lang === 'ko'
                    ? dayjs(date).format('YYYY년 MM월 DD일')
                    : dayjs(date).format('MM/DD/YYYY');
            };
            
            let _assessment_info_table_body = [
                [
                    {
                        content: this.$t('평가기간', this.report_lang),
                        styles: {...this.tableStyles.th, cellWidth: _column_width_1}
                    },
                    // @todo 하드코딩 수정 필요.
                    {
                        // content: `${getFormattedDate('2025-09-01')} ~ ${getFormattedDate('2025-10-17')}`,
                        content: `${getFormattedDate('2025-09-01')} ~ ${this.assessmentInfo.duedate_date}`,
                        styles: {...this.tableStyles.td, cellWidth: _column_width_2}
                    }
                ],
            ];
            const { project_code } = this.assessmentInfo;
            if (ksteelReportYear(project_code) !== '2025') {
                // 2026~ 은 다른 렌더러(supply)와 같이 DB(df_nice_service_request) 신청일 ~ 마감일
                _assessment_info_table_body[0][1].content = `${this.assessmentInfo.requested_date} ~ ${this.assessmentInfo.duedate_date}`;
            } else if(project_code !== 'SEAH_CSS_25'  &&  project_code !== 'SEAH_BESTEEL_25' ){
                // 2025 는 이미 발행된 보고서와 맞추려고 종전 고정값 유지
                _assessment_info_table_body[0][1].content = `${getFormattedDate('2025-09-01')} ~ ${getFormattedDate('2025-10-31')}`;
            }
            
            if ((this.assessmentType && this.assessmentType === 'OSIS') || (!this.assessmentType && this.reportData.info.service_type === '심화')) {
                _assessment_info_table_body.push(
                    [
                        {
                            content: this.$t('평가유형', this.report_lang),
                            styles: {...this.tableStyles.th, cellWidth: _column_width_1}
                        },
                        {
                            content: this.$t('실사평가', this.report_lang),
                            styles: {...this.tableStyles.td, cellWidth: _column_width_2}
                        }
                    ]
                );
            }
            
            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: this.jsPDFOpt.margin,
                styles: this.tableStyles.global,
                body: _assessment_info_table_body
            });
            
            return doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
        },
        async summary_processCodeCompliance(doc, position_y) {
            const chartXPos = this.jsPDFOpt.margin.left + 8;
            const rightContentXPos = chartXPos + 100 + 16;
            const rightContentWidth = (this.pageContentWidth - rightContentXPos + 20).toFixed(1);
            const {total,processedTotalCodeData} = this.levelData; 
            
            position_y = this.addTitle(doc, position_y, 2, this.$t('ESG Code 준수율', this.report_lang));
            this.setFont(doc, 'table_td', null, 'bold');
            doc.setFontSize(11);
            const complianceMsg = doc.splitTextToSize(summaryMsg.complianceRateMsg(this.report_lang, this.companyInfo['회사명'], this.levelData), rightContentWidth);
            const complianceMsgDim = doc.getTextDimensions(complianceMsg);
            const complianceTableHeight = 62;
            const complianceMsgPosY = position_y + 16;
            let complianceChartPosY = position_y + 8;
            
            let codeCardHeight = 116;
            if (complianceMsgDim > 100) {
                codeCardHeight = complianceMsgDim.h + complianceTableHeight + 16;
                complianceChartPosY = position_y + (codeCardHeight - 100) / 2;
            }
            
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, codeCardHeight, 'F');
            
            doc.text(complianceMsg, rightContentXPos, complianceMsgPosY);
            
            
            const rightPositionY = complianceMsgPosY + complianceMsgDim.h;
            const cellStyle = {...this.tableStyles.th, lineColor: '#292929', lineWidth: 1};
            
            autoTable(doc, {
                theme: 'grid',
                startY: rightPositionY,
                tableWidth: rightContentWidth,
                margin: {...this.jsPDFOpt.margin, top: 0, left: rightContentXPos},
                styles: {...this.tableStyles.global, halign: 'center'},
                body: [
                    [
                        {
                            content: this.$t('미준수', this.report_lang),
                            styles: {...cellStyle, fontStyle:'bold',  fillColor: rgbaToRgb([...this.ksteel_colors.nonCompliance_rgb, 0.5])},
                            colSpan: 2
                        },
                        {
                            content: this.$t('준수', this.report_lang),
                            styles: {...cellStyle, fontStyle:'bold', fillColor: rgbaToRgb([...this.ksteel_colors.compliance_rgb, 0.5])},
                            colSpan: 2
                        },
                    ],
                    [
                        {
                            content: this.$t('매우 미흡', this.report_lang),
                            styles: {
                                ...cellStyle,
                                cellWidth: rightContentWidth * 0.25,
                                fillColor: rgbaToRgb([...this.ksteel_colors.nonCompliance_rgb, 0.3])
                            }
                        },
                        {
                            content: this.$t('미흡', this.report_lang),
                            styles: {
                                ...cellStyle,
                                cellWidth: rightContentWidth * 0.25,
                                fillColor: rgbaToRgb([...this.ksteel_colors.nonCompliance_rgb, 0.3])
                            }
                        },
                        {
                            content: this.$t('보통', this.report_lang),
                            styles: {
                                ...cellStyle,
                                cellWidth: rightContentWidth * 0.25,
                                fillColor: rgbaToRgb([...this.ksteel_colors.compliance_rgb, 0.3])
                            }
                        },
                        {
                            content: this.$t('우수', this.report_lang),
                            styles: {
                                ...cellStyle,
                                cellWidth: rightContentWidth * 0.25,
                                fillColor: rgbaToRgb([...this.ksteel_colors.compliance_rgb, 0.3])
                            }
                        },
                    ],
                    [
                        {
                            content: this.$t('개수', this.report_lang, {count: processedTotalCodeData.D}),
                            styles: {...cellStyle, fillColor: rgbaToRgb([...this.ksteel_colors.nonCompliance_rgb, 0.2])},
                        },
                        {
                            content: this.$t('개수', this.report_lang, {count: processedTotalCodeData.C}),
                            styles: {...cellStyle, fillColor: rgbaToRgb([...this.ksteel_colors.nonCompliance_rgb, 0.2])},
                        },
                        {
                            content: this.$t('개수', this.report_lang, {count: processedTotalCodeData.B}),
                            styles: {...cellStyle, fillColor: rgbaToRgb([...this.ksteel_colors.compliance_rgb, 0.2])},
                        },
                        {
                            content: this.$t('개수', this.report_lang, {count: processedTotalCodeData.A}),
                            styles: {...cellStyle, fillColor: rgbaToRgb([...this.ksteel_colors.compliance_rgb, 0.2])},
                        },
                    ]
                ]
            });
            
            this.setFont(doc, 'table_td', null);
            doc.setTextColor(100, 100, 100);
            doc.setFontSize(9);
            const complianceTableHelpMsg = doc.splitTextToSize(this.$t('* 미준수: \'매우 미흡 \' 및 \'미흡\' Code', this.report_lang), this.pageContentWidth);
            const complianceTableHelpMsgDim = doc.getTextDimensions(complianceTableHelpMsg);
            const complianceTableHelpMsgPosX = this.pageContentWidth + this.jsPDFOpt.margin.left - complianceTableHelpMsgDim.w - 9;
            doc.text(complianceTableHelpMsg, complianceTableHelpMsgPosX, doc.lastAutoTable.finalY + 10);
            
            const complianceRate =  this.roundToOneDecimalPlace((processedTotalCodeData.compliance / processedTotalCodeData.total) * 100);
            const nonComplianceRate =  this.roundToOneDecimalPlace((processedTotalCodeData.nonCompliance / processedTotalCodeData.total) * 100);
            
            const codeComplianceRateChart = await this.generateCodeSummaryPieChartInstance(
                [complianceRate, nonComplianceRate],
                {data1: this.ksteel_colors.compliance, data2: this.ksteel_colors.nonCompliance},
            );
            await waitTime(100);
            doc.addImage(codeComplianceRateChart, 'PNG', chartXPos, complianceChartPosY, 100, 100, undefined, 'FAST');
            this.codeDoughnutChartInstance?.destroy();
            this.codeDoughnutChartInstance = null;
            
            this.setFont(doc, 'table_td', null, 'bold');
            doc.setTextColor(29, 29, 29);
            doc.setFontSize(24);
            const complianceRateText = doc.splitTextToSize(total.total_compliance + '%', this.pageContentWidth);
            const complianceRateTextDim = doc.getTextDimensions(complianceRateText);
            const complianceRateTextPosX = chartXPos + (100 - complianceRateTextDim.w) / 2;
            const complianceRateTextPosY = complianceChartPosY + 100 - (100 - complianceRateTextDim.h) / 2;
            doc.text(complianceRateText, complianceRateTextPosX, complianceRateTextPosY);
            
            
            position_y += codeCardHeight + this.jsPDFOpt.spacing.section_xs;
            
            return {chartXPos, rightContentXPos, position_y};
        },
        async summary_processUnknown(doc, position_y, chartXPos, rightContentXPos) {
            position_y = this.addTitle(doc, position_y, 2, this.$t('평가 신뢰도', this.report_lang));
            
            const {unknownData} = this.subBaseData;
            let reliability = 'HIGH';
            
            this.setFont(doc, 'table_td', null, 'semibold');
            doc.setTextColor(29, 29, 29);
            doc.setFontSize(13);
            const unknownText = doc.splitTextToSize(this.$t('유효 응답률', this.report_lang), this.pageContentWidth);
            const unknownTextDim = doc.getTextDimensions(unknownText);
            const unknownTextXPos = chartXPos + (100 - unknownTextDim.w) / 2;
            doc.text(unknownText, unknownTextXPos, position_y + 12);
            
            const guideTextBoxYPos = position_y + 6;
            const guideTextBoxWidth = this.pageContentWidth - rightContentXPos + 29;
            doc.setLineWidth(0.8);
            doc.setDrawColor(100, 100, 100);
            doc.rect(rightContentXPos, guideTextBoxYPos, guideTextBoxWidth, 116, 'S');
            
            this.setFont(doc, 'table_td', null, 'semibold');
            doc.setTextColor(29, 29, 29);
            doc.setFontSize(15);
            const reliabilityText = doc.splitTextToSize(this.$t('신뢰도', this.report_lang) + ':', this.pageContentWidth);
            const reliabilityTextYPos = guideTextBoxYPos + 20;
            const reliabilityTextXPos = rightContentXPos + 8;
            doc.text(reliabilityText, reliabilityTextXPos, reliabilityTextYPos);
            
            doc.setTextColor(this.ksteel_colors.compliance);
            if (unknownData.validRate < 60) {
                reliability = 'LOW';
                doc.setTextColor(this.ksteel_colors.nonCompliance);
            } else if (unknownData.validRate < 80 && unknownData.validRate >= 60) {
                reliability = 'MID';
                doc.setTextColor(this.ksteel_colors.warning);
            }
            const reliabilityDataXPos = reliabilityTextXPos + doc.getTextDimensions(reliabilityText).w + 4;
            doc.text(reliability, reliabilityDataXPos, reliabilityTextYPos);
            
            const reliabilityGuideText = '* HIGH: 100 ~ 80%, MID: 80 ~ 60%, LOW: 60% ~ 0%';
            const reliabilityGuideTextYPos = reliabilityTextYPos + 10;
            this.setFont(doc, 'table_td', null, 'normal');
            doc.setTextColor(100, 100, 100);
            doc.setFontSize(9);
            doc.text(reliabilityGuideText, reliabilityTextXPos, reliabilityGuideTextYPos);
            
            doc.setTextColor(29, 29, 29);
            doc.setFontSize(11);
            const unknownGuideText = doc.splitTextToSize(summaryMsg.assessmentRateMsg(this.report_lang, this.companyInfo['회사명'], unknownData, reliability), this.pageContentWidth - reliabilityTextXPos + 22);
            doc.text(unknownGuideText, reliabilityTextXPos, reliabilityGuideTextYPos + 20);
            
            const unKnownRate = await this.generateCodeSummaryPieChartInstance(
                [unknownData.validRate, 100 - unknownData.validRate],
                {data1: this.ksteel_colors.compliance, data2: this.ksteel_colors.gray},
            );
            await waitTime(100);
            const unknownChartPosY = position_y + 8 + 12;
            doc.addImage(unKnownRate, 'PNG', chartXPos, unknownChartPosY, 100, 100, undefined, 'FAST');
            this.codeDoughnutChartInstance?.destroy();
            this.codeDoughnutChartInstance = null;
            
            this.setFont(doc, 'table_td', null, 'bold');
            doc.setTextColor(29, 29, 29);
            doc.setFontSize(24);
            const unknownRateText = doc.splitTextToSize(unknownData.validRate.toString() + '%', this.pageContentWidth);
            const unknownRateTextDim = doc.getTextDimensions(unknownRateText);
            const unknownRateTextPosX = chartXPos + (100 - unknownRateTextDim.w) / 2;
            const unknownRateTextPosY = unknownChartPosY + 100 - (100 - unknownRateTextDim.h) / 2;
            doc.text(unknownRateText, unknownRateTextPosX, unknownRateTextPosY);
            
            return position_y;
        },
        generateCodeSummaryPieChartInstance(codeComplianceData, colors) {
            return new Promise((resolve) => {
                const _scope1_data = {
                    datasets: [{
                        data: codeComplianceData,
                        fill: true,
                        backgroundColor: [
                            colors.data1,
                            colors.data2
                        ],
                        borderColor: [
                            colors.data1,
                            colors.data2
                        ],
                    }]
                };
                
                const _common_option = {
                    global: {
                        aspectRatio: 5 / 5,
                        responsive: false,
                        maintainAspectRatio: false,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0,
                            onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    },
                    plugins: {
                        datalabels: {display: false}
                    },
                };
                
                const _scope1_area_option = {
                    ..._common_option.global,
                    elements: {line: {borderWidth: 1}},
                    scales: {},
                    plugins: _common_option.plugins,
                    cutout: '77.5%'
                };
                
                if (!this.codeDoughnutChartInstance) {
                    this.codeDoughnutChartInstance = this.$chartjs.createChart(
                        document.getElementById('code-summary-pie-chart'),
                        {
                            type: 'doughnut',
                            data: _scope1_data,
                            options: _scope1_area_option
                        }
                    );
                } else {
                    this.$chartjs.updateChart(this.codeDoughnutChartInstance, _scope1_data, _scope1_area_option);
                }
            });
            
            // return this.drawCategory1PieChartImage()
        },
        drawCategory1PieChartImage() {
            return this.codeDoughnutChartInstance.toBase64Image('image/jpg', 1);
        },
        addDocPage(doc, alreadyAdded = false) {
            if (!alreadyAdded)
                doc.addPage();
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            doc.addImage(background_texture_img, 'PNG', 0, 0, pageWidth, pageHeight, undefined, 'FAST');
        },
        generateCover_ksteel(doc) {
            try {
                // 페이지 너비,높이
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();
                
                const maxWidth = pageWidth - 20; // 페이지의 여백을 고려한 너비
                const maxHeight = pageHeight - 20; // 페이지의 여백을 고려한 높이
                
                // 표지 색상 설정
                doc.setFillColor(this.ksteel_colors.primary); // RGB 값
                doc.rect(0, 0, pageWidth, pageHeight, 'F'); // 'F'는 fill
                
                const cover_hyundai_logo_position_x = 30;
                const cover_hyundai_logo_position_y = 40;
                
                const ksteelLogoSize = {
                    width: 151 / 1.6, height: 32 / 1.6
                };
                
                const qesgLogoSize = {
                    width: 3747 / 45, height: 942 / 45
                };
                
                // 철강협회 로고 추가
                doc.addImage(KSTEELLogoWhite, 'png', cover_hyundai_logo_position_x, cover_hyundai_logo_position_y - 3, ksteelLogoSize.width, ksteelLogoSize.height);
                doc.setTextColor('#FFFFFF');
                doc.setFontSize(20);
                
                // QESG 로고 추가
                doc.addImage(QESGLogoWhite, 'png', 333, cover_hyundai_logo_position_y - 5, qesgLogoSize.width, qesgLogoSize.height);
                
                
                let _text_position_y = (maxHeight / 3) + (this.jsPDFOpt.margin.top * 1.25);
                let _text_position_x = this.jsPDFOpt.margin.left;
                
                const additional_info_position_y = _text_position_y - 40;
                // "재평가 결과보고서" 문구 추가
                if (this.is_reassessment) {
                    this.setFont(doc, 'title');
                    doc.setTextColor('#FFFFFF');
                    const _reassessment_report_title = doc.splitTextToSize(`[${this.$t('재평가 결과보고서', this.report_lang)}]`, this.pageContentWidth);
                    doc.text(_reassessment_report_title, _text_position_x, additional_info_position_y, {align: 'left'});
                }
                
                // 심화평가 문구 추가 ("재평가 결과보고서" 문구가 추가되면 심화평가 문구는 추가 안됨)
                if (!this.is_reassessment && ((this.assessmentType && this.assessmentType === 'OSIS') || (!this.assessmentType && this.reportData.info.service_type === '심화'))) {
                    this.setFont(doc, 'title');
                    doc.setTextColor('#FFFFFF');
                    const _osis_report_title = doc.splitTextToSize(`[${this.$t('실사평가 결과보고서', this.report_lang)}]`, this.pageContentWidth);
                    doc.text(_osis_report_title, _text_position_x, additional_info_position_y, {align: 'left'});
                }
                
                // 보고서 이름 추가
                this.setFont(doc, 'cover_name_lg');
                doc.setTextColor('#FFFFFF');
                const [_report_title_width, _report_title_height] = [doc.getTextDimensions(this.cover_title).w, doc.getTextDimensions(this.cover_title).h];
                
                
                doc.text(this.cover_title, _text_position_x, _text_position_y, {});
                
                // 보고서 기업명 추가
                if (this.report_lang === 'ca' && this.isChineseOrHanzi(this.companyInfo['회사명'])) {
                    this.setFont(doc, 'cover_company_name_lg', this.jsPDFOpt.fontFamily_ca);
                } else {
                    this.setFont(doc, 'cover_company_name_lg', this.jsPDFOpt.fontFamily);
                }
                
                const _company_name = doc.splitTextToSize(this.companyInfo['회사명'], this.pageContentWidth);
                _text_position_y += _report_title_height + (this.jsPDFOpt.margin.top * 0.75);
                doc.setTextColor('#FFFFFF');
                doc.text(_company_name, _text_position_x, _text_position_y);
                
                // disclaimer 추가
                /**
                 * 969696
                 */
                this.setFont(doc, 'title_sm', this.jsPDFOpt.fontFamily);
                doc.setTextColor('#FFFFFF');
                doc.text('Disclaimer', 30, maxHeight - 37, {});
                
                doc.setDrawColor('#FFFFFF'); // RGB 값
                doc.setLineWidth(0.5);                // 굵은 선
                doc.line(28, maxHeight - 32, this.report_lang === 'en' ? 300 : 280, maxHeight - 32); // 좌측 20~우측 190, y=40 위치에 가로선
                
                const texts = [
                    `- ${this.$t('result_report_disclaimer.text1', this.report_lang)}`,
                    `  ${this.$t('result_report_disclaimer.text2', this.report_lang)}`,
                ];
                
                // 각 줄별로 출력 (들여쓰기 반영)
                const lineHeight = 9;
                const leftMargin = 30;
                let y = maxHeight - 22; // 시작 위치
                texts.forEach((line, idx) => {
                    
                    this.setFont(doc, 'footnote', this.jsPDFOpt.fontFamily);
                    doc.setTextColor('#FFFFFF');
                    doc.text(line, leftMargin, y);
                    y += lineHeight;
                });
            } catch (error) {
                console.log(error);
            }
        },
    }
};
